<script lang="ts">
  import { Button, FormGroup, Icon, Input, InputGroup, Label, Popover } from "sveltestrap";
  import AppWraper from "../components/AppWraper.svelte";
  import { Diligence } from "../Model/Diligence";
  import type { SubtypesDiligences } from "../Model/SubtypesDiligences";
  import ParamSelect from "../components/ParamSelect.svelte";
  import { complainantGenderService, complainantService, denouncedGenderService, denouncedService, diligencesService, fileServices, paramsService, policeManifestationGenderService, policeManifestationGeneralService, policeManifestationService, policeManifestationTrafficService, thirdsService, usersService, witnessGenderService, witnessService, writeFileService } from "../services";
  import { subtypesDiligencesService } from "../services";
  import { dateInputFormatter, dateTimeInputFormatter } from "../services/Functions";
  import DiligenceVictimForm from "../components/Diligence/GenderViolence/DiligenceVictimForm.svelte";
  import DiligenceTrafficForm from "../components/Diligence/Traffic/DiligenceTrafficForm.svelte";
  import DiligenceActaForm from "../components/Diligence/Acta/DiligenceActaForm.svelte";
  import DiligenceGeneralForm from "../components/Diligence/General/DiligenceGeneralForm.svelte";
  import { navigate } from "svelte-navigator";
  import { v4 as v4uuid } from "uuid";
  import type { User } from "../Model/User";
  import { success, error } from '../../public/my-theme';
  import MapView from "../components/MapView.svelte";
  import UserMarker from "../components/UserMarker.svelte";
  import type { Coords } from "../interfaces";
  import type { PoliceManifestationTraffic } from "../Model/PoliceManifestationTraffic";
  import type { PoliceManifestation } from "../Model/PoliceManifestation";
  import { setContext } from "svelte";
  import { writable } from "svelte/store";
  import type { PoliceManifestationGender } from "../Model/PoliceManifestationGender";
  import DiligenceLostForm from "../components/Diligence/Lost/DiligenceLostForm.svelte";
  import type { PoliceManifestationGeneral } from "../Model/PoliceManifestationGeneral";
    import SendEmailModal from "../components/SendEmailModal.svelte";
    import type { AppFileDto } from "../global";
    import DownloadFilesModal from "../components/DownloadFilesModal.svelte";

  const policeManifestationInitial$ = writable<PoliceManifestation>(null)
  setContext('policeManifestationInitial', policeManifestationInitial$);

  const policeManifestationFinish$ = writable<PoliceManifestation>(null)
  setContext('policeManifestationFinish', policeManifestationFinish$);

  const policeManifestationTraffic$ = writable<PoliceManifestationTraffic>(null)
  setContext('policeManifestationTraffic', policeManifestationTraffic$);

  const policeManifestationGender$ = writable<PoliceManifestationGender>(null)
  setContext('policeManifestationGender', policeManifestationGender$);

  const policeManifestationGeneral$ = writable<PoliceManifestationGeneral>(null)
  setContext('policeManifestationGeneral', policeManifestationGeneral$);

  export let diligenceId: string;

  let newDiligence = false;

  let diligence: Diligence;
  let subtypes: SubtypesDiligences[];

  let policeManifestationTraffic: PoliceManifestationTraffic;
  let policeManifestationGender: PoliceManifestationGender;
  let policeManifestationGeneral: PoliceManifestationGeneral;
  let policeManifestationInitial: PoliceManifestation;
  let policeManifestationFinish: PoliceManifestation;

  let diligenceNumber: string;
  let searchPosition: boolean = false;

  let date: string = dateInputFormatter(new Date());
  let time: string = dateTimeInputFormatter(new Date());

  let offset: number = 0;
  let limit: number = 179;
  let searchFilter = null;

  let mapView: boolean = false

  let coords: Coords = null

  let formType: string = "";
  let type: any;

  //files
  let files: AppFileDto[] = null;
  let filesToDownload: any[] = [];
  let pop: boolean = false;
  let filesToSend: AppFileDto[] = null;

  let diligenceInfo: Diligence;
  let policeManifestation: PoliceManifestationTraffic | PoliceManifestationGender | PoliceManifestationGeneral | PoliceManifestation;

  const delay = (ms: any | undefined) => new Promise(res => setTimeout(res, ms));

  const formAux = {
    'violenciaGenero': DiligenceVictimForm,
    'acta': DiligenceActaForm,
    'trafico': DiligenceTrafficForm,
    'general': DiligenceGeneralForm,
    'perdido': DiligenceLostForm,
  }

  $: loadDiligence(diligenceId);
  $: loadSubtypesDiligences();

  async function findDiligenceNumber() {
    return await diligencesService.findLastDiligenceNumber(
      parseInt(date.substring(0, 5))
    );
  }

  async function loadPoliceManifestationTraffic(diligenceId: string) {
    try {
      policeManifestationTraffic = await policeManifestationTrafficService.findOneByDiligenceNumber(diligenceId);
      policeManifestationTraffic$.set(policeManifestationTraffic);
    } catch (error) {
      policeManifestationTraffic = await policeManifestationTrafficService.createPoliceManifestationTraffic(diligenceId)
    }
  }

  async function loadPoliceManifestationGender(diligenceId: string) {
    try {
      policeManifestationGender = await policeManifestationGenderService.findOneByDiligenceNumber(diligenceId);
      policeManifestationGender$.set(policeManifestationGender);
    } catch (error) {
      policeManifestationGender = await policeManifestationGenderService.createPoliceManifestationGender(diligenceId)
    }
  }

  async function loadPoliceManifestationGeneral(diligenceId: string) {
    try {
      policeManifestationGeneral = await policeManifestationGeneralService.findOneByDiligenceNumber(diligenceId);
      policeManifestationGeneral$.set(policeManifestationGeneral);
    } catch (error) {
      policeManifestationGeneral = await policeManifestationGeneralService.createPoliceManifestationGeneral(diligenceId)
    }
  }

  async function loadpoliceManifestation(diligenceId: string) {
    try {
      policeManifestationInitial = await policeManifestationService.findOneByDiligenceNumber(diligenceId, 'initial');
      policeManifestationFinish = await policeManifestationService.findOneByDiligenceNumber(diligenceId, 'finish');

      if (!policeManifestationInitial) {
        policeManifestationInitial = await policeManifestationService.createPoliceManifestation(diligenceId, 'initial');

      }

      if (!policeManifestationFinish) {
        policeManifestationFinish = await policeManifestationService.createPoliceManifestation(diligenceId, 'finish');
      }
      
      policeManifestationInitial$.set(policeManifestationInitial);
      policeManifestationFinish$.set(policeManifestationFinish);
    } catch (error) {
      console.log(error);
    } 
  }

  async function loadDiligence(diligenceId: string): Promise<void> {
    if (diligenceId != "new") {
      try {
        diligence = await diligencesService.findOne(diligenceId);
        await loadpoliceManifestation(diligenceId);

        if (formType == 'trafico') {
          await loadPoliceManifestationTraffic(diligenceId)
        }
        if (formType == 'violenciaGenero') {
          await loadPoliceManifestationGender(diligenceId)
        }
        if(formType == 'general') {
          await loadPoliceManifestationGeneral(diligenceId)
        }

        await getFiles();

      } catch (err) {
        navigate("/diligencias");
      }
      try {
        date = dateInputFormatter(diligence.entryDate);
        time = dateTimeInputFormatter(diligence.entryDate);
      } catch (err) {}
      return;
    }else{

      newDiligence = true;

      diligenceNumber = await (await findDiligenceNumber()).toString();

      diligence = new Diligence({
        id: v4uuid(),
        diligenceNumber: diligenceNumber,
        entryDate: date + "T" + time + ":00.000Z",
        instructorId: null,
        secretaryId: null,
        courtId: null,
        diligenceTypeId: null,
        subDiligenceTypeId: null,
        userId: getUser(),
        proceedingsNumber: " ",
        coords: {
          lat: null,
          lon: null
        }
      });
      
      geolocation();
    }

  }


  async function changeDiligenceNumber() {
    diligence.diligenceNumber = await (await findDiligenceNumber()).toString();
    diligence.entryDate = date + "T" + time + ":00.000Z";
  }

  $: loadType(diligence);

  async function loadType(dilig: Diligence) {
    if (
      dilig == undefined ||
      dilig.diligenceTypeId == null ||
      dilig.diligenceTypeId == ""
    ) {
      formType = "";
      return;
    }

    type = await paramsService.findOne(dilig.diligenceTypeId);

    switch (type.name.trim()) {
      case "ATROPELLO":
      case "Atestado de Tráfico":
      case "CAIDA MOTORISTA":
      case "CHOQUE":
      case "CHOQUE DAÑOS MATERIALES":
      case "COLISION EN CADENA":
      case "COLISION FRONTAL":
      case "COLISION FRONTAL ANGULA":
      case "COLISION FRONTAL EXCENTRICA IZQUIERDA":
      case "COLISION FRONTOLATERAL ANTERIOR":
      case "COLISION FRONTOLATERAL CON RESULTADO DE VUELCO":
      case "COLISION LATERAL ANTERIOR":
      case "COLISION POR RASPADO NEGATIVO (MISMO SENTIDO)":
      case "COLISION POR RASPADO POSITIVO (SENTIDO CONTRARIO)":
      case "CONTROL ALEATORIO":
      case "EMBESTIDA OBLICUA ANTERIOR":
      case "EMBESTIDA OBLICUA POSTERIOR":
      case "NO PROCEDE DE ACCIDENTE":
      case "POR ALCANCE":
      case "SALIDA DE VIA":
        formType = "trafico";
        break;

      case "Violencia de Género":
        formType = "violenciaGenero";
        break;

      case "Acta":
        formType = "acta";
        break;

      case "CAIDA":
      case "DAÑOS MATERIALES":
      case "Denuncia General":
        formType = "general";
        break;
      
      case "Objeto Perdido":
        formType = "perdido";
        break;
      default:
        formType = "";
        break;
    }
  }

  async function loadSubtypesDiligences() {
    let opts = {
      offset: offset,
      limit: limit,
      filters: {
        search: searchFilter,
      },
    };

    subtypes = await subtypesDiligencesService.findSubtypes(opts);

    subtypes.sort((a, b) => {
      return a.subTypeDiligence < b.subTypeDiligence ? -1 : 1;
    });
  }

  function geolocation(){
    searchPosition = true;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
      
        if (!position){
          searchPosition = false;
          return;
        } 
        
        diligence.coords = {
          lat: position.coords.latitude,
          lon: position.coords.longitude 
        }
        
        searchPosition = false;
      }); 
    }else{
      searchPosition = false;
    }
  }

  function showMap(){
    if (!diligence.coords) return;
    mapView = !mapView;
  }

  function getUser(): string {
    let user: User = JSON.parse(localStorage.getItem("current_user"));
    return user.id;
  }

  async function save (){
    try {
      if (!newDiligence) {
        await diligencesService.saveDiligence(diligence)
        await policeManifestationService.savePoliceManifestation(policeManifestationInitial);
        await policeManifestationService.savePoliceManifestation(policeManifestationFinish);

        if (formType == 'trafico') {
          await policeManifestationTrafficService.savePoliceManifestationTraffic(policeManifestationTraffic);
        }

        if (formType == 'violenciaGenero') {
          await policeManifestationGenderService.savePoliceManifestationGender(policeManifestationGender);
        }

        success('Diligencia actualizada')
      }else{
        if(diligence.diligenceTypeId != null && diligence.subDiligenceTypeId != null) {
        
          await diligencesService.saveDiligence(diligence)

          policeManifestationInitial = await policeManifestationService.createPoliceManifestation(diligence.id, 'initial');
          policeManifestationFinish = await policeManifestationService.createPoliceManifestation(diligence.id, 'finish');

          if (formType == 'trafico') {
            await policeManifestationTrafficService.createPoliceManifestationTraffic(diligence.id)
          }
          if (formType == 'violenciaGenero') {
            await policeManifestationGenderService.createPoliceManifestationGender(diligence.id)
          }
          if(formType == 'general') {
            await policeManifestationGeneralService.createPoliceManifestationGeneral(diligence.id); 
          }

          newDiligence = false;

          navigate(`/diligencias/${diligence.id}`)
        } else {
          error('Debe de rellenar el tipo de diligencia y el subtipo')
        }
      }

    } catch(err) {
      console.log(err);
      error('Comprueba los campos');
    }
  }

  async function download(){
    if(newDiligence) return;

    try {

      if(formType == 'violenciaGenero') {
        diligenceInfo = diligence;
        policeManifestation = policeManifestationGender;

        /* filesToDownload.forEach(async (file) => {
          await writeFileService.writeGenderFile(diligence, policeManifestationInitial, policeManifestationFinish, policeManifestationGender, file);
        }) */
        
      }

      if(formType == 'trafico') {  

        diligenceInfo = diligence;
        policeManifestation = policeManifestationTraffic;
        
        /* filesToDownload.forEach(async (file) => {
          await writeFileService.writeTrafficFile(diligence, policeManifestationInitial, policeManifestationFinish, policeManifestationTraffic, file)
        }) */
      }

      if(formType == 'general') {
        diligenceInfo = diligence;
        policeManifestation = policeManifestationGeneral;

        /* filesToDownload.forEach(async (file) => {
          await writeFileService.writeGeneralFile(diligence, policeManifestationInitial, policeManifestationFinish, policeManifestationGeneral, file);
        }) */
      }

      if(formType == 'acta') {
        diligenceInfo = diligence;

        /* filesToDownload.forEach(async (file) => {
          await writeFileService.writeActFile(diligence, policeManifestationInitial, policeManifestationFinish, file);
        }) */
      }

      if(formType == 'perdido') {
        diligenceInfo = diligence;

        /* filesToDownload.forEach(async (file) => {
          await writeFileService.writeObjectFile(diligence, policeManifestationInitial, policeManifestationFinish, file);
        }) */
      }

    } catch (error) {
      console.log(error);
    }
  }

  async function getFiles() {
    files = await fileServices.findFilesByContext(diligence.id);
    files = files;
  }

</script>

<AppWraper>

  {#if diligence}
  <div class="fixed-sup">
    <div class="row">
      <div class="col-8">
        <div class="text-start">
            <h3><span class="mobile-view">Diligencia</span> Nº {diligence.diligenceNumber}</h3>
        </div>
      </div>
      <div class="col-4 text-end">
        {#if diligenceId == "new"}
          <button type="button" class="btn btn-primary" on:click={() => { save() }}>Siguiente</button>
        {:else}
          <button type="button" class="btn btn-primary" on:click={download} ><!-- on:click={() => { {loadFiles(); pop == false ? pop = true : pop = false} }} -->
            <Icon name=download /> <span class="mobile-view">Ficheros</span>
          </button>
          <button type="button" class="btn btn-success" on:click={() => { save() }}>
            <Icon name=save /> <span class="mobile-view">Guardar</span>
          </button>
          <button type="button" class="btn btn-success" id='pop' on:click={() => filesToSend = files}>
            <Icon name=envelope /> 
          </button>
          <Popover
            trigger="hover"
            placement="bottom"
            target="pop"
          >
            Enviar correo.
          </Popover>
        {/if}
      </div>
    </div>
    <div class='pop bg-white shadow-lg rounded-3 border border-1' >
      {#if pop}
            
        <div class='bg-light p-2 border- border-bottom'>
          Seleccione ficheros
        </div>
        <div class='p-4 d-flex flex-column size'>
          {#if files.length > 0}
            {#each files as file} 
              <FormGroup>
                <Input type="checkbox" label={file.name} on:change={() => {filesToDownload.push(file.id)}} />
              </FormGroup>
              <!-- <button class='btn btn-secondary mb-2 fs-6' on:click={async() => {download(file.id); await delay(500).then(() => pop = false) }}>{file.name}</button> -->
            {/each}
            <button type="button" class="btn btn-primary mt-3" on:click={() => { download() }}>
              <Icon name=download /> <span class="mobile-view">Descargar</span>
            </button>
          {:else}
            <span>No hay ficheros para descargar</span>
          {/if}
        </div>
      {/if}
      
    </div>
  </div>
    <div class="mb-5 container-top">
      <div class="container mb-3">
          <div class="border rounded p-2 pb-0">
            <div class="row">
              <div class="col-12 col-md-3 mt-2 mb-3">
                <Label for="mark">Nº Diligencia</Label>
                <Input
                  type="text"
                  bind:value={diligence.diligenceNumber}
                  readonly
                />
              </div>
              <div class="col-12 col-md-3 mt-2 mb-3">
                <Label for="mark">Fecha</Label>
                <Input
                  type="date"
                  bind:value={date}
                  on:change={changeDiligenceNumber}
                />
              </div>
              <div class="col-12 col-md-3 mt-2 mb-3">
                <Label for="mark">Hora</Label>
                <Input
                  type="time"
                  bind:value={time}
                  on:change={changeDiligenceNumber}
                />
              </div>
              <div class="col-12 col-md-3 mt-2">
                <Label for="mark">Coordenadas</Label>
                <InputGroup>
                  {#if diligence.coords}
                    <Input value={diligence.coords.lat + "," + diligence.coords.lon} readonly />
                  {:else}
                    <Input value={0 + "," + 0} readonly />
                  {/if}
                  
                  <Button color="secondary" on:click={geolocation} disabled={searchPosition}>
                    {#if searchPosition}
                      <span class="loader"></span>
                    {:else}
                      <Icon  name="geo-alt-fill"/>
                    {/if}
                  </Button>
                </InputGroup>
                <Button class="p-0" color="link" on:click={showMap}>(ver mapa)</Button> 
              </div>      
            </div>
            <div class="row">
              
              <div class="col-md-3">
                
              </div>
              <div class="col-12 col-md-3 mt-2 mb-3">
                <Label for="mark">Nº Instructor</Label>
                <ParamSelect
                  bind:paramSelectId={diligence.instructorId}
                  paramType="agentList"
                  nothing={true}
                />
              </div>
              <div class="col-12 col-md-3 mt-2 mb-3">
                <Label for="mark">Nº Secretario</Label>
                <ParamSelect
                  bind:paramSelectId={diligence.secretaryId}
                  paramType="agentList"
                  nothing={true}
                />
              </div>
              <div class="col-12 col-md-3 mt-2 mb-3">
                <Label for="mark">Nº Expediente</Label>
                <Input
                  type="text"
                  bind:value={diligence.proceedingsNumber}
                />
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-3 mt-2 mb-3">
                <Label for="mark">Tipo de Diligencia</Label>
                <ParamSelect
                  bind:paramSelectId={diligence.diligenceTypeId}
                  paramType="diligencesTypes"
                  nothing={false}
                />
              </div>
              <div class="col-12 col-md-5 mt-2 mb-3">
                <Label for="mark">Subtipo</Label>
                <Input type="select" bind:value={diligence.subDiligenceTypeId}>
                  {#if subtypes != undefined}
                    <option>Selecciona un subtipo</option>
                    {#each subtypes as tipo}
                      {#if diligence.diligenceTypeId === tipo.diligenceCode}
                        <option value={tipo.id}>{tipo.subTypeDiligence}</option>
                      {/if}
                    {/each}
                  {:else}
                    <option>---</option>
                  {/if}
                </Input>
              </div>
              <div class="col-12 col-md-4 mt-2 mb-3">
                <Label for="mark">Remisión</Label>
                <ParamSelect
                  bind:paramSelectId={diligence.courtId}
                  paramType="courts"
                  nothing={true}
                />
              </div>
              {#if diligence.coords && mapView}
                <div class="col-12 mt-2 mb-3">
                  <div class="col-12">
                      <div class="map-view-container mb-3">
                          <MapView center={diligence.coords}>
                              <UserMarker bind:location={diligence.coords} />
                          </MapView>
                      </div>
                  </div>
                </div>
              {/if}
              {#if diligenceId != "new"}
                <svelte:component this={formAux[formType]} diligence={diligence}/>
              {/if}
            </div>
          </div>
      </div>
    </div>
  {/if}
</AppWraper>

<SendEmailModal files={filesToSend} />
<DownloadFilesModal 
  diligence={diligenceInfo} 
  {formType} 
  {policeManifestationFinish} 
  {policeManifestationInitial} 
  {policeManifestation}
  pics={files}
/>

<style lang="scss">

    .size {
      min-width: 18rem;
    }

    .pop {
      position: absolute;
      top: 70px;
      right: 100px;
      width: auto;
    }

    .map-view-container{
      height: 300px;
    }

    .loader {
      width: 20px;
      height: 20px;
      border: 5px solid #FFF;
      border-bottom-color: transparent;
      border-radius: 50%;
      display: inline-block;
      box-sizing: border-box;
      animation: rotation 1s linear infinite;
      }

      @keyframes rotation {
      0% {
          transform: rotate(0deg);
      }
      100% {
          transform: rotate(360deg);
      }
    } 

    .fixed-sup{
      position: sticky;
      width: 100%;
      top: 54px;
      z-index: 999;
      background-color: #fff;
      padding: 20px 35px 15px 35px;
    }

    .container-top{
      margin-top: 60px;
    }

</style>